import { h } from 'preact';
import { useState } from 'preact/hooks';
import Icon from '../utils/icon';
import ProductSwatchesSamples from './product-swatches-samples';


const ProductAccordions = ({ product, currentVariant }) => {
  const [activeElements, setActiveElements] = useState([]);

  const handleClick = (index) => {
    const newActiveElements = [...activeElements];
    newActiveElements[index] = !newActiveElements[index];
    setActiveElements(newActiveElements);
  };
  const swatchesSamplesEnabled = product.productSwatchesSamples;
  const swatchesContent = product.productSwatchesContent;
  const swatchesTitle = product.productSwatchesTitle;
  const swatchesSamples = currentVariant?.swatchesSamples;
  const variantSwatchesAvailable = swatchesSamples?.some(
    (sample) => sample.productAvailable === true
  );

  const renderContent = (html) => {
    if (typeof html === 'string') {
      return html
        .replace(/&lt;p[^&]*&gt;/g, '<p>')
        .replace(/&lt;\/p&gt;/g, '</p>')
        .replace(
          /<span[^>]*class=["']metafield-multi_line_text_field["'][^>]*>/g,
          ''
        )
        .replace(/<\/span>/g, '')
        .replace(/\\n/g, '<br>');
    }

    return html;
  };

  return (
    <div className="px-3 md:px-16">
      {product?.blocks.map((block, index) => {
        if (block.blockType === 'accordion_metafield') {
          // eslint-disable-next-line no-param-reassign
          block.content =
            currentVariant[block.metafieldString] ||
            currentVariant[block.metafieldStringFallback];
        }

        const renderBlock =
          (block.title && block.content) || // IF block has title and content,
          (block?.title?.toLowerCase().includes('assembly') && // OR block title includes "assembly", AND assembly is required AND an assembly guide is provided
            currentVariant?.assemblyGuide &&
            product?.assemblyRequired);

        return (
          renderBlock && (
            <div className="border-b py-5" key={block.id} data-foo="a">
              <button
                className="flex items-center justify-between w-full body-2 uppercase font-medium"
                aria-expanded={activeElements[index]}
                onClick={() => {
                  handleClick(index);
                }}
              >
                {block.title}
                <span className={activeElements[index] ? 'rotate-180' : ''}>
                  <Icon name="carret" />
                </span>
              </button>

              <div className={`pt-4 ${activeElements[index] ? '' : 'hidden'}`}>
                {block.title.toLowerCase().includes('assembly') && (
                  <div>
                    {currentVariant?.assemblyGuide &&
                      product?.assemblyRequired && (
                        <div className="flex justify-between">
                          <div className="flex gap-2 mb-4 body-2 items-center">
                            <Icon name="checkCircle" />
                            <span>
                              {window.TMW.Strings.product.assemblyCopy}
                            </span>
                          </div>
                          {currentVariant?.assemblyGuide && (
                            <a
                              className="body-2 cursor-pointer whitespace-nowrap"
                              href={currentVariant?.assemblyGuide?.url}
															target="_blank"
															rel="noreferrer"
                            >
                              {window.TMW.Strings.product.assemblyGuide}
                            </a>
                          )}
                        </div>
                      )}
                    {product?.timeToAssemble && (
                      <div className="flex gap-2 mb-4 body-2 items-center">
                        <Icon name="clock" />
                        <span>{product?.timeToAssemble}</span>
                      </div>
                    )}
                  </div>
                )}
                {block.content && (
                  <div className="rte body-2 [&>div>p]:!body-2 [&>div>ul]:!body-2 w-full">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: renderContent(block.content),
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )
        );
      })}
      {swatchesSamplesEnabled &&
        swatchesContent &&
        variantSwatchesAvailable && (
          <div className="border-b py-5">
            <button
              className="flex items-center justify-between w-full body-2 uppercase font-medium"
              aria-expanded={activeElements[product?.blocks.length]}
              onClick={() => {
                handleClick(product?.blocks.length);
              }}
            >
              {swatchesTitle}
              <span
                className={
                  activeElements[product?.blocks.length] && 'rotate-180'
                }
              >
                <Icon name="carret" />
              </span>
            </button>
            <div
              className={`pt-4 ${
                !activeElements[product?.blocks.length] && 'hidden'
              }`}
            >
              <div className="rte [&>div>p]:!body-2 [&>div>ul]:!body-2">
                <div dangerouslySetInnerHTML={{ __html: swatchesContent }} />
              </div>
              <ProductSwatchesSamples currentVariant={currentVariant} />
            </div>
          </div>
        )}
    </div>
  );
};

export default ProductAccordions;
